import React, { useRef } from "react";
import useScrollAnimation from "../hooks/useScrollAnimation";
import { energyConcepts } from "../data/siteData";
import "./About.css";

export default function About() {
  const conceptRefs = useRef([]);

  const sectionRef = useScrollAnimation(({ gsap, ScrollTrigger, el }) => {
    gsap.from(el.querySelectorAll(".about__statement span"), {
      yPercent: 110,
      opacity: 0,
      duration: 0.9,
      stagger: 0.08,
      ease: "power4.out",
      scrollTrigger: { trigger: el, start: "top 75%" },
    });

    conceptRefs.current.forEach((node, i) => {
      if (!node) return;
      gsap.from(node, {
        y: 60,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: { trigger: node, start: "top 85%" },
        delay: i * 0.05,
      });
    });

    gsap.from(el.querySelectorAll(".about__narrative-text"), {
      y: 40,
      opacity: 0,
      duration: 0.9,
      ease: "power3.out",
      scrollTrigger: { trigger: el.querySelector(".about__narrative"), start: "top 75%" },
    });
  }, []);

  return (
    <section id="energy" className="about section" ref={sectionRef}>
      <div className="about__grid-bg" aria-hidden="true" />
      <div className="container">
        <span className="eyebrow">The Energy Of Selectra</span>
        <h2 className="about__statement">
          <span>ENERGY SHOULD</span>
          <span className="glow-text">DO MORE.</span>
        </h2>

        <div className="about__concepts">
          {energyConcepts.map((c, i) => (
            <div
              className="about__concept"
              key={c.number}
              ref={(el) => (conceptRefs.current[i] = el)}
            >
              <span className="about__concept-number">{c.number}</span>
              <h3 className="about__concept-title">{c.title}</h3>
              <p className="about__concept-text">{c.text}</p>
            </div>
          ))}
        </div>

        <div className="about__narrative">
          <div className="about__narrative-image" />
          <div className="about__narrative-text">
            <span className="eyebrow">About Selectra</span>
            <h2 className="about__narrative-title">
              WE DON'T JUST
              <br />
              INSTALL SOLAR.
              <br />
              <span className="glow-text">WE DESIGN ENERGY.</span>
            </h2>
            <p>
              Since our first installation, Selectra Solar has treated every
              rooftop as a unique engineering problem — not a catalogue
              order. Our in-house design team models sun path, shading and
              consumption before a single panel is quoted.
            </p>
            <p>
              That discipline shows up in the details: mounting hardware
              rated for coastal humidity and Tamil Nadu's monsoon winds,
              cabling routed for serviceability, and inverter placement that
              makes maintenance simple rather than an afterthought.
            </p>
            <p>
              Every system ships with active monitoring and a support line
              answered by engineers who understand your specific
              installation — not a call centre script.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
